import { getShape1D } from 'ml-peak-shape-generator';
export class BaseSpectrumGenerator {
    from;
    to;
    nbPoints;
    interval;
    peakWidthFct;
    shape;
    constructor(options = {}) {
        const { from = 0, to = 1000, nbPoints = 10001, peakWidthFct, shape = { kind: 'gaussian', fwhm: 5 }, } = options;
        assertNumber(from, 'from');
        assertNumber(to, 'to');
        assertInteger(nbPoints, 'nbPoints');
        if (to <= from) {
            throw new RangeError('to option must be larger than from');
        }
        if (peakWidthFct && typeof peakWidthFct !== 'function') {
            throw new TypeError('peakWidthFct option must be a function');
        }
        this.from = from;
        this.to = to;
        this.nbPoints = nbPoints;
        this.interval = (to - from) / (nbPoints - 1);
        this.peakWidthFct = peakWidthFct;
        this.shape = getShape1D(shape);
    }
    /**
     * Resolves a peak to its canonical parameters, cloning and configuring
     * separate shape instances for the left and right halves.
     */
    resolvePeak(peak, options) {
        let x0;
        let intensity;
        let peakFWHM;
        let peakWidth;
        let peakShapeOptions;
        if (Array.isArray(peak)) {
            [x0, intensity, peakFWHM, peakShapeOptions] = peak;
        }
        else {
            x0 = peak.x;
            intensity = peak.y;
            peakWidth = peak.width;
            peakShapeOptions = peak.shape;
        }
        let { shape: shapeOptions } = options;
        if (peakShapeOptions) {
            shapeOptions = shapeOptions
                ? { ...shapeOptions, ...peakShapeOptions }
                : peakShapeOptions;
        }
        const shape = shapeOptions
            ? getShape1D(shapeOptions)
            : cloneShape(this.shape);
        const { width } = options;
        let { widthLeft, widthRight } = options;
        const fwhm = peakFWHM !== undefined
            ? peakFWHM
            : peakWidth
                ? shape.widthToFWHM(peakWidth)
                : this.peakWidthFct
                    ? this.peakWidthFct(x0)
                    : width !== undefined
                        ? width
                        : shape.fwhm;
        if (!widthLeft)
            widthLeft = fwhm;
        if (!widthRight)
            widthRight = fwhm;
        if (!widthLeft || !widthRight) {
            throw new Error('Width left or right is undefined or zero');
        }
        const factor = options.factor === undefined ? shape.getFactor() : options.factor;
        const shapeLeft = cloneShape(shape);
        shapeLeft.fwhm = widthLeft;
        const shapeRight = cloneShape(shape);
        shapeRight.fwhm = widthRight;
        return {
            x0,
            intensity,
            shapeLeft,
            shapeRight,
            widthLeft,
            widthRight,
            factor,
        };
    }
}
function cloneShape(shape) {
    return Object.assign(Object.create(Object.getPrototypeOf(shape)), shape);
}
function assertInteger(value, name) {
    if (!Number.isInteger(value)) {
        throw new TypeError(`${name} option must be an integer`);
    }
}
function assertNumber(value, name) {
    if (!Number.isFinite(value)) {
        throw new TypeError(`${name} option must be a number`);
    }
}
//# sourceMappingURL=BaseSpectrumGenerator.js.map